/// <reference path="../../components/common/businessinfo.service.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../adpIntegration/adpIntegration.controller.ts" />

module Meevo.Plugins.AdpWfnIntegration {
    class AdpWfnIntegrationController extends Meevo.Plugins.AdpIntegration.AdpIntegrationController {
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.Common.AdpIntegrationService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityService: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            $rootScope: angular.IRootScopeService,
            $scope: angular.IScope,
            $state: any,
            protected $translate: angular.translate.ITranslateService,
            contextParams: Meevo.IContextParams,
            shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            busyService: Meevo.Components.Busy.IBusyService       ) {

            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityService,
                trackingService,
                $rootScope,
                $scope,
                $state,
                contextParams,
                shortCutsService,
                busyService
            );
        }


        createContext(): void {
            let vm = this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.INTEGRATION_ADPWFNINTEGRATION).then(() => {
                vm.busyService.stop();
                vm.context = new AdpWfnIntegrationContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, vm.securityService, vm.trackingService, vm.busyService, vm.$rootScope, vm.$translate, vm.contextParams);

                super.createContext();
            });
        }
    }

    angular.module("meevo.plugins.adpIntegration")
        .controller("meevo.plugins.adpWfnIntegration.adpWfnIntegrationController", AdpWfnIntegrationController);
}

